// src/components/ConfirmationModal.js
import React from 'react';

// *** NEU: Props für Button-Text und Farbe hinzugefügt ***
const ConfirmationModal = ({ 
    isOpen, 
    onClose, // Wird nicht direkt verwendet, aber gute Praxis
    onConfirm, 
    onCancel, 
    title = "Bestätigung", 
    message,
    confirmText = "Bestätigen", // Default: Bestätigen
    cancelText = "Abbrechen",   // Default: Abbrechen
    confirmColor = "bg-red-600 hover:bg-red-700" // Default: Rot (für Löschen etc.)
}) => {
  if (!isOpen) return null;

  // Handler, um Propagation zu verhindern
  const handleModalClick = (e) => {
    e.stopPropagation(); 
  };
  
  // *** NEU: Cancel-Button Farbe (konsistent grau) ***
  const cancelColor = "bg-gray-300 hover:bg-gray-400 text-gray-800";

  return (
    // Overlay
    <div 
        className="fixed inset-0 z-50 bg-black bg-opacity-60 backdrop-blur-sm flex items-center justify-center p-4" 
        onClick={onCancel} // Schließen bei Klick auf Overlay
    >
      {/* Modal-Container */}
      <div 
        className="relative z-50 bg-white dark:bg-gray-800 rounded-2xl shadow-2xl w-full max-w-md p-6 border border-gray-200 dark:border-gray-700"
        onClick={handleModalClick} // Verhindert Schließen bei Klick ins Modal
      >
        <h3 className="text-xl font-bold mb-4 text-gray-900 dark:text-white">{title}</h3>
        <p className="text-gray-700 dark:text-gray-300 mb-6">{message}</p>
        <div className="flex justify-end space-x-3">
          <button 
            // *** NEU: Verwendet cancelText und cancelColor ***
            onClick={onCancel} 
            className={`px-5 py-2 rounded-lg font-medium transition-colors duration-200 ${cancelColor}`}
          >
            {cancelText}
          </button>
          <button 
            // *** NEU: Verwendet confirmText und confirmColor ***
            onClick={onConfirm} 
            className={`px-5 py-2 rounded-lg font-medium text-white transition-colors duration-200 ${confirmColor}`}
          >
            {confirmText} 
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
